import { usePage } from '@inertiajs/inertia-vue3';
import { ref } from 'vue';

const Typesense = require('typesense');

export function useTypesenseEvents() {
    const events = ref([]);
    const page = ref(1);
    const query = ref('');
    const lat = ref('');
    const lng = ref('');

    let clientConfigured = false;
    let client = null;

    try {
        const config = usePage().props.value.typesense;

        client = new Typesense.Client({
            nodes: [
                {
                    host: config.host,
                    port: config.port,
                    protocol: config.protocol,
                },
            ],
            apiKey: config.search_key,
            connectionTimeoutSeconds: 10,
        });

        clientConfigured = true;
    } catch (e) {
        console.log('Typesense client not configured', e);
    }

    async function search(newQuery = '', newLat = '', newLng = '', newPage = 1, newCompanySlug = '') {
        query.value = newQuery;
        lat.value = newLat;
        lng.value = newLng;
        page.value = newPage;

        events.value = await getEvents();
    }

    async function loadMore() {
        page.value++;
        let newEvents = await getEvents();
        events.value = [...events.value, ...newEvents];
    }

    async function getEvents() {
        if (!clientConfigured) {
            return [];
        }

        let searchParameters = {
            q: query.value,
            query_by: 'title_fr,title_en,company_name',
            sort_by: '',
            page: page.value,
            per_page: 9,
        };

        let sort_by = lat.value && lng.value ? `location(${lat.value}, ${lng.value}):asc,updated_at:desc` : `updated_at:desc`;

        searchParameters.sort_by = sort_by;

        let filter_by = `is_active:true`;

        // Website
        // Website - CAMAQ = 63
        filter_by += ' && websites:63';

        // Language
        let language = usePage().props.value.locale;
        filter_by += ` && (language:${language} || language:bi)`;

        searchParameters.filter_by = filter_by;

        let indexName = usePage().props.value.typesense.events_index_name;
        let result = await client.collections(indexName).documents().search(searchParameters);

        return result.hits.map(hit => {
            return hit.document;
        });
    }

    return {
        events,
        search,
        loadMore,
    };
}
